import { createFileRoute, stripSearchParams } from '@tanstack/react-router';

import { DeliveriesAllV2Page } from '~/modules/deliveriesAllV2';

import { i18n } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';
import { getRouteHead } from '~/utils/routeUtils';

import { routeParams, searchDefaults, validateSearch } from './-routeParams';

const title = i18n.t(($) => $.pageTitle.list, { ns: 'delivery' });

export const Route = createFileRoute('/(main)/deliveries/all-v2/')({
  beforeLoad: createProtectedRoute({
    routePath: '/deliveries/all-v2/',
    ...routeParams,
  }),
  component: DeliveriesAllV2Page,
  head: () => getRouteHead(title),
  search: {
    middlewares: [stripSearchParams(searchDefaults)],
  },
  staticData: {
    AppBar: {
      title,
    },
  },
  validateSearch,
});

export const DELIVERIES_V2 = buildRouteExport({
  Route,
  ...routeParams,
});
